import React, { useEffect, useState } from 'react';
import news1 from '../images/news1.png';
import news2 from '../images/news2.png';
import news3 from '../images/news3.png';
import news4 from '../images/news4.png';
import news5 from '../images/news5.png';
import styled from 'styled-components';

const News: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // 컴포넌트 마운트 후 애니메이션 시작
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <NewsContainer className={isLoaded ? 'loaded' : ''}>
      <NewsHeader className={isLoaded ? 'animate' : ''}>
        <div className="container">
          <NewsTitle>언론보도</NewsTitle>
        </div>
      </NewsHeader>

      <FeaturedNewsSection className={isLoaded ? 'animate' : ''}>
        <div className="container">
          <FeaturedBadge>FEATURED NEWS</FeaturedBadge>
          
          <FeaturedArticle href="https://www.chungbuk.co.kr/news/articleView.html?idxno=1051234" target="_blank" rel="noopener noreferrer">
            <FeaturedImageWrapper>
              <img src={news1} alt="충북일보 기사" />
            </FeaturedImageWrapper>
            <FeaturedContent>
              <h2>"환경 혁신을 이끄는 식품 폐기물 처리 솔루션"</h2>
              <p>조세원(33) ㈜제로원 대표이사는 '식품 폐기물 순환경제'에 대한 자신의 소신을 힘주어 강조했다.</p>
              <p>최근 지속가능성과 환경 문제가 중요한 화두로 떠오르면서 이에 대한 해결책을 제시하는 기업들이 주목받고 있다.</p>
              <div className="featured-meta">
                <span className="source">충북일보</span>
                <span className="date">2025. 2. 24.</span>
              </div>
            </FeaturedContent>
          </FeaturedArticle>
        </div>
      </FeaturedNewsSection>

      <RecentArticlesSection className={isLoaded ? 'animate' : ''}>
        <div className="container">
          <RecentBadge>RECENT ARTICLES</RecentBadge>
          
          <ArticlesGrid>
            <ArticleCard href="https://www.unicornfactory.co.kr/article/2025011013595416133" target="_blank" rel="noopener noreferrer" className={isLoaded ? 'animate' : ''} style={{ animationDelay: '0.2s' }}>
              <div className="article-image">
                <img src={news2} alt="유니콘팩토리 기사" />
              </div>
              <div className="article-content">
                <h3>'식품 폐기물 재활용 원료 전환' 제로원, 중기부 팁스 선정</h3>
                <div className="article-meta">
                  <span className="source">유니콘팩토리</span>
                  <span className="date">2025. 1. 10.</span>
                </div>
              </div>
            </ArticleCard>

            <ArticleCard href="https://news.mt.co.kr/mtview.php?no=2024112214502632636" target="_blank" rel="noopener noreferrer" className={isLoaded ? 'animate' : ''} style={{ animationDelay: '0.4s' }}>
              <div className="article-image">
                <img src={news3} alt="머니투데이 기사" />
              </div>
              <div className="article-content">
                <h3>'식품폐기물, 가치 높여 처리' 제로원, 블루포인트 시드투자 유치</h3>
                <div className="article-meta">
                  <span className="source">머니투데이</span>
                  <span className="date">2024. 11. 23.</span>
                </div>
              </div>
            </ArticleCard>

            <ArticleCard href="https://www.jbnews.com/news/articleView.html?idxno=1457173" target="_blank" rel="noopener noreferrer" className={isLoaded ? 'animate' : ''} style={{ animationDelay: '0.6s' }}>
              <div className="article-image">
                <img src={news4} alt="중부매일 기사" />
              </div>
              <div className="article-content">
                <h3>청년창업파크, 성과공유회 열려…각 부문별 수상</h3>
                <div className="article-meta">
                  <span className="source">중부매일</span>
                  <span className="date">2024. 10. 30.</span>
                </div>
              </div>
            </ArticleCard>

            <ArticleCard href="http://www.zero1ne.com/bbs/board.php?bo_table=media_news&wr_id=11" target="_blank" rel="noopener noreferrer" className={isLoaded ? 'animate' : ''} style={{ animationDelay: '0.8s' }}>
              <div className="article-image">
                <img src={news5} alt="제로원 기사" />
              </div>
              <div className="article-content">
                <h3>제로원, 2022 예비창업패키지 IR경진대회 대상 수상</h3>
                <div className="article-meta">
                  <span className="source">제로원</span>
                  <span className="date">2023. 1. 13.</span>
                </div>
              </div>
            </ArticleCard>
          </ArticlesGrid>
        </div>
      </RecentArticlesSection>
    </NewsContainer>
  );
};

// Styled Components
const NewsContainer = styled.main`
  min-height: 100vh;
  background: #21004d;
`;

const NewsHeader = styled.section`
  background: #21004d;
  padding: 120px 0 80px;
  text-align: center;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;
    
    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const NewsTitle = styled.h1`
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 60px;
  font-weight: bold;
  color: white;
  margin: 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 40px;
  }

  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

const FeaturedNewsSection = styled.section`
  background: #21004d;
  padding: 0 0 100px;
  text-align: center;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease 0.2s;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;
    
    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const FeaturedBadge = styled.div`
  display: inline-block;
  background-color: rgb(235, 184, 0);
  color: black;
  padding: 4px 16px;
  border-radius: 30px;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 40px;
  border: 3px solid rgb(235, 98, 0);
  text-transform: uppercase;
  letter-spacing: 1px;
  
  @media (max-width: 480px) {
    font-size: 20px;
    padding: 3px 14px;
  }
`;

const FeaturedArticle = styled.a`
  display: flex;
  gap: 60px;
  align-items: center;
  text-decoration: none;
  color: inherit;
  border-radius: 20px;
  overflow: hidden;
  transition: transform 0.3s ease;
  border: 3px solid rgb(235, 98, 0);
  padding: 30px;
  background: #2a0061;
  backdrop-filter: blur(10px);
  text-align: left;
  
  &:hover {
    transform: translateY(-5px);
  }
  
  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 40px;
    padding: 20px;
  }
`;

const FeaturedImageWrapper = styled.div`
  flex: 1;
  position: relative;
  border-radius: 17px;
  margin: -33px -33px -33px -33px;
  
  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 17px;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40%;
    background: linear-gradient(to top, rgba(0,0,0,0.6), transparent);
    border-radius: 0 0 17px 17px;
  }
`;

const FeaturedContent = styled.div`
  flex: 1;
  color: white;

  h2 {
    font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
    font-size: 32px;
    font-weight: normal;
    line-height: 1.3;
    margin-bottom: 30px;
    color: white;

    @media (max-width: 768px) {
      font-size: 28px;
    }

    @media (max-width: 480px) {
      font-size: 24px;
    }
  }

  p {
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 20px;
    line-height: 1.7;
    color: white;
    margin-bottom: 20px;

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  .featured-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 30px;
    font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
    font-size: 20px;
    color: white;

    .source {
      font-weight: 600;
    }

    .date {
      font-weight: 400;
    }

    @media (max-width: 480px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      font-size: 18px;
    }
  }
`;

const RecentArticlesSection = styled.section`
  background: #21004d;
  padding: 100px 0;
  text-align: center;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease 0.4s;
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
  }
  
  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 105px;
    
    @media (max-width: 1024px) {
      padding: 0 32px;
    }

    @media (max-width: 480px) {
      padding: 0 20px;
    }
  }
`;

const RecentBadge = styled.div`
  display: inline-block;
  background-color: rgb(235, 184, 0);
  color: black;
  padding: 4px 16px;
  border-radius: 30px;
  font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
  font-size: 24px;
  font-weight: normal;
  margin-bottom: 60px;
  border: 3px solid rgb(235, 98, 0);
  text-transform: uppercase;
  letter-spacing: 1px;
  
  @media (max-width: 480px) {
    font-size: 20px;
    padding: 3px 14px;
  }
`;

const ArticlesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  text-align: left;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 30px;
  }
`;

const ArticleCard = styled.a`
  display: flex;
  flex-direction: column;
  background: #2a0061;
  border-radius: 20px;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  border: 3px solid rgb(235, 98, 0);
  height: 100%;
  opacity: 0;
  transform: translateY(50px);
  
  &.animate {
    opacity: 1;
    transform: translateY(0);
    transition: all 0.8s ease;
  }
  
  &:hover {
    transform: translateY(-10px);
  }
  
  .article-image {
    width: calc(100% + 6px);
    height: 200px;
    overflow: hidden;
    margin: -3px -3px 0 -3px;
    border-radius: 17px 17px 0 0;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      transition: transform 0.3s ease;
      border-radius: 17px 17px 0 0;
    }
  }
  

  
  .article-content {
    padding: 40px 30px 30px;
    color: white;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    
    h3 {
      font-family: "HGAlmond 80g", "HGAlmond 80g Placeholder", sans-serif;
      font-size: 32px;
      font-weight: normal;
      line-height: 1.4;
      margin-bottom: 40px;
      color: white;
      
      @media (max-width: 480px) {
        font-size: 28px;
        margin-bottom: 30px;
      }
    }
    
    .article-meta {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-family: "Pretendard Regular", "Pretendard Regular Placeholder", sans-serif;
      font-size: 20px;
      font-weight: bold;
      color: white;
      margin-top: auto;
      
      .source {
        font-weight: bold;
        color: white;
      }
      
      .date {
        color: white;
      }
      
      @media (max-width: 480px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        font-size: 18px;
      }
    }
  }
`;

export default News;